import React from 'react';
import PageHeader from './components/PageHeader';
import SettingsAIConfig from './SettingsAIConfig';

function AIConfigPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <PageHeader
        title="AI Configuration"
        subtitle="Configure AI-powered quote text generation"
        backTo="/settings-landing"
        backLabel="Settings"
        sticky
      />
      <main className="max-w-7xl mx-auto px-6 py-8">
        <SettingsAIConfig />
      </main>
    </div>
  );
}

export default AIConfigPage;
